import { WbsListDto } from '@api/client';
import { useMemo } from 'react';

const useGetWbsTotals = (deliverablesTableDataShown: WbsListDto[] | undefined, totalRevenues: number) => {
  const monthsCount = deliverablesTableDataShown?.[0]?.wbsPlanningDtoList?.length ?? 0;

  const totalPercentagePerMonth = useMemo<number[]>(() => {
    const totals: number[] = new Array(monthsCount).fill(0);

    deliverablesTableDataShown?.forEach((deliverable) => {
      deliverable.wbsPlanningDtoList?.forEach((allocation, monthIndex) => {
        totals[monthIndex] = (totals[monthIndex] ?? 0) + (allocation.corrispettivo ?? 0);
      });
    });

    return totals;
  }, [deliverablesTableDataShown, monthsCount]);

  const totalCostPerMonth = useMemo<number[]>(() => {
    const totals: number[] = new Array(monthsCount).fill(0);

    deliverablesTableDataShown?.forEach((deliverable) => {
      deliverable.wbsPlanningDtoList?.forEach((allocation, monthIndex) => {
        totals[monthIndex] =
          (totals[monthIndex] ?? 0) +
          ((totalRevenues / 100) * (deliverable.pesoAttivita ?? 0) * (allocation.corrispettivo ?? 0)) / 100;
      });
    });

    return totals;
  }, [deliverablesTableDataShown, totalRevenues, monthsCount]);

  return {
    totalPercentagePerMonth,
    totalCostPerMonth,
  };
};

export default useGetWbsTotals;
